import React, { Component } from 'react';
/* Components */
import LoadingModal from '../common/loadingModal';
import ExtendedPropertyCreator from '../common/extended_property/extendedPropertyCreator';

const ModalCreate = props => (
  <div
    data-close="ok"
    onClick={props.handleModal}
    className={props.modal ? `container-modal` : `container-modal hide`}
  >
    <section className="module-title modal-title">
      <h2>{props.language.account.accountExtendedProperty.modal.createTitle}</h2>
      {props.statusSave == 500 &&
        props.dataSave.error.params.map((item, i) => (
          <p key={i} className="error">
            {props.language.error[`cod${item.messageCode}`]}{' '}
          </p>
        ))}
      <a>
        <i data-close="ok" onClick={props.handleModal} className="fas fa-times-circle" />
      </a>
    </section>
    {props.statusSave != 200 && (
      <div className={`box-modal max500`}>
        <section id="modal-create" className="base-form">
          <div className="box-form islabel">
            <div>
              <label className="modal-label">
                {props.language.account.accountExtendedProperty.modal.name}
                <strong> (*)</strong> <p>{props.language.account.accountExtendedProperty.help.formName}</p>
              </label>
            </div>
            <div>
              <input autoComplete="off" type="text" id="name" className="modal-input" />
            </div>
          </div>
          <div className="box-form islabel">
            <div>
              <label className="modal-label">
                {props.language.account.accountExtendedProperty.table.dataType}
                <strong> (*)</strong> <p>{props.language.account.accountExtendedProperty.help.formDataType}</p>
              </label>
            </div>
            <div>
              <ul className="multiple-select radio" id={"list-type"} data-list={"list-type"}>
                {props.types.map(item => {
                  return (
                    <li
                      onClick={props.handleSelect}
                      data-parent={"list-type"}
                      id={"list-type-" + item.toLowerCase()}
                      key={"list-type-" + item.toLowerCase()}
                      data-value={item}
                    >
                      {props.language.account.accountExtendedProperty.table[item.toLowerCase()]}
                    </li>      
                  )
                })}
              </ul>
            </div>
          </div> 
          <div className="box-form islabel">
            <div>
              <label className="modal-label">
                {props.language.account.accountExtendedProperty.table.owner}
                <strong> (*)</strong> <p>{props.language.account.accountExtendedProperty.help.formOwner}</p>
              </label>
            </div>
            <div>
              <ul className="multiple-select radio" id={"list-owner"} data-list={"list-owner"}>
                {props.crudTypes.map(item => {
                  return (
                    <li
                      onClick={props.handleSelect}
                      data-parent={"list-owner"}
                      id={"list-owner-" + item.toLowerCase()}
                      key={"list-owner-" + item.toLowerCase()}
                      data-value={item}
                    >
                      {props.language.account.accountExtendedProperty.table[item.toLowerCase()]}
                    </li>      
                  )
                })}
              </ul>
            </div>
          </div>          
        </section>
      </div>
    )}
    {props.statusSave != 200 && (
      <div className={'box-form islabel top center modal-button-box'}>
        <div>
          {props.loadingSave ? (
            <div className="spiner">
              <i className="fas fa-spinner fa-spin" />
              {" " + props.language.account.accountExtendedProperty.modal.loading}
            </div>
          ) : (
            <input
              className="active"
              onClick={props.handleSubmit}
              type="button"
              value={props.language.account.accountExtendedProperty.modal.buttonCreate}
            />
          )}
        </div>
      </div>
    )}
    {props.statusSave == 200 && (
      <div className={`box-modal max500`}>
        <section className={'feed-back green'}>
          <div>
            <i className="fas fa-check-circle" />
          </div>
          <div>
            <p>{props.language.account.accountExtendedProperty.modal.feedBackOk}</p>
          </div>
        </section>
      </div>
    )}
  </div>
);

export default ModalCreate;



// WEBPACK FOOTER //
// ./source/client/components/account_extended_property/modalCreate.jsx